import {faro} from '@grafana/faro-react';
import {setUser} from '@sentry/react';
import {useSuspenseQuery} from '@tanstack/react-query';
import {setFaroTraceIdentity, whoamiSchema} from 'shared';

import {api} from '@/lib/ky';

import {userKeys} from './queryKeys';

import type {ExtractFnReturnType, QueryConfig} from '@/lib/react-query';

export const getWhoami = async () => {
  const data = await api.get(`users/whoami`).json();
  const parsed = whoamiSchema.parse(data);

  setUser({
    id: parsed.id,
    email: parsed.email,
  });
  faro.api?.setUser({id: parsed.id});
  setFaroTraceIdentity({
    companyId: parsed.companyId,
    email: parsed.email,
  });

  return parsed;
};

export const useWhoami = (config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...config,
    queryKey: userKeys.whoami,
    queryFn: () => getWhoami(),
  });
};

type QueryFnType = typeof getWhoami;
